import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../../../utils/propUtils';
import VeltCommentsSidebarV2FilterContainerSectionControlChip from './VeltCommentsSidebarV2FilterContainerSectionControlChip/VeltCommentsSidebarV2FilterContainerSectionControlChip';
var VeltCommentsSidebarV2FilterContainerSectionControlChipList = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-container-v2-section-control-chip-list-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarV2FilterContainerSectionControlChipList.Chip = VeltCommentsSidebarV2FilterContainerSectionControlChip;
export default VeltCommentsSidebarV2FilterContainerSectionControlChipList;
